<template>
    <el-container>
        <el-header>
            <commonheader :isNavShow='true'></commonheader>
        </el-header>

        <el-container class="el-container-master">
            <el-aside style="width:220px">
                <leftMenu></leftMenu>
            </el-aside>
            <el-main>
                <section class="flex">
                    <exit></exit>

                    <div class="content">
                        <div class="onlineTeachingCont">

                            <div class="onlineTeachingContRight">
                                <div class="onlineTeachingContPadding">
                                    <div class="onlineTeachingContTop">
                                        <div class="classTypesSelect" v-show='year_show'>
                                            选择继续教育学年:
                                            <el-select  v-model="year_value" placeholder="请选择" @change="yearChange">
                                                <el-option v-for="item in year" :key="item.year" :label="item.year"
                                                    :value="item.year">
                                                </el-option>
                                            </el-select>
                                        </div>

                                        <div class="classTypesTab">
                                            <p v-for="(item, idx) in classTypesTabData" :key="idx"
                                                :class="{'active':activeIdx === idx}" @click="classTypesTabEvent(idx)">
                                                {{item.title}}</p>
                                        </div>


                                        <!--网授课程模块-->
                                        <net-class v-show="this.activeIdx == 0" ref='netClass' :netClassData='netClassData' :courseTypeJson="courseTypeJson" :courseList='courseList' :car='car' :year_value='year_value' @hideYear='hideYear'></net-class>

                                        <!--面授课程模块-->
                                        <face-class v-show="this.activeIdx == 1" :courseList='faceCourseList' :year_value='year_value'></face-class>
                                    </div>

                                </div>

                            </div>
                        </div>

                        <el-dialog title="重要提示" class="player" center :visible.sync="player" width='30%' :before-close="playerClose" custom-class="custom-dialog-title">
                            <p>{{courseTypeJson.msg1}}</p>
                            <p v-if="courseTypeJson.need_all==2"><a href="https://mp.weixin.qq.com/s/ZYoPvYiLOaoqAvqZoJhI9Q" target="_blank">《执业药师继续教育暂行规定》学时计算标准</a></p>
                            <span slot="footer" class="dialog-footer">
                                <el-button type="primary" @click="player = false">知道了</el-button>
                            </span>
                        </el-dialog>

                    </div>

                </section>
            </el-main>
        </el-container>
    </el-container>

</template>


<script>
import commonheader from '../../common/commonHeader.vue' //头部组件
import leftMenu from "../../common/leftMenu.vue";
import exit from "../../common/exit.vue";
import faceClass from "./faceClass.vue";
import netClass from "./netClass.vue";

export default {
    name: "index",
    components: {
        commonheader,
        leftMenu,
        exit,
        faceClass,
        netClass,
    },
    data () {
        return {
            year: [],
            year_value: '',
            year_show: true,

            classTypesTabData: [
                {
                    'title': '网授课程'
                },
                {
                    'title': '面授课程'
                }
            ],
            activeIdx: 0,

            isShowFaceSelcetAddressFlag: true,
            isShowFaceSelectClassesFlag: false,
            isShowFaceSelectClassesDetailFlag: false,

            isShowoOnlineCourseListFlag: true,
            isShowConfirmOnlineCourseSignUpList: false,
            isShowConfirmOnlineCourseSignUpPopFlag: false,

            courseList: [],
            car:'',
            faceCourseList: [],

            //网授课我的课程列表
            netClassData:{},
            courseTypeJson:{},
            player:false
        };
    },
    mounted: function () {
        document.getElementsByTagName("html")[0].className = "my-page";
        // console.log(this.$route.query)
        this.getYear();

    },

    methods: {
        /**
         * 获取年份
         */
        getYear(){
            this.$store.dispatch('academic_year',{}).then((res) => {
                if( res.data.length ){
                    this.year = res.data;
                    if( this.$route.query.year ){
                        this.year_value = this.$route.query.year;
                    }else{
                        this.year_value = res.data[0].year;
                    }
                    this.getMyCourse();
                    this.getCourseType()

                }else{
                    this.courseList = [];
                }
            })
        },

        /**
         * 获得本年度报课类型
         */
        getCourseType(){
          let params = {
              year: this.year_value,

          };

          console.log(1111)
          this.$store.dispatch('get_course_type', params).then((res) => {
            console.log(res)
              if (res.code == 200) {
                this.courseTypeJson=res.data
                 this.player = true
              }

          }).catch(() => {

          })
        },

        /**
         * 关闭超出限制弹窗
         */
        playerClose () {
            this.player = false;
        },

        /**
         * 获取可报名的课程
         * year  年份
         * type  教育类型： 1 网授 2 面授
         */
        getMyCourse (){

            let params = {
                year:this.year_value,
                type:this.activeIdx+1
            }

            this.$store.dispatch('webcourses',params).then((res) => {
                //course_type  课程类型 1 必修 2 选修
                if( this.activeIdx+1 == 1 ){
                    this.courseList = res.data.courses;
                    this.car = String(res.data.car);
                }else{
                    this.faceCourseList = res.data.courses;
                }
            })

            this.$store.dispatch('mycourses', params).then((res) => {
                // res.data.courses = [];
                //course_type  课程类型 1 必修 2 选修
                this.netClassData = res.data;
            })
        },

        /**
         * 年份改变
         */
        yearChange(){
            this.$refs.netClass.clearSelectedCourse();
            this.getMyCourse();
            this.getCourseType()
        },

        /**
         * 隐藏年份
         */
        hideYear(flg){
            this.year_show = flg ? false : true;
        },

        classTypesTabEvent (idx) {

            if (idx == 0) {
                this.activeIdx = idx
                this.isShowoOnlineCourseListFlag = true;
                this.isShowConfirmOnlineCourseSignUpList = false;
                this.isShowConfirmOnlineCourseSignUpPopFlag = false;
            }


            if (idx == 1) {
                this.$message('暂无课程');
                return false;

                this.isShowFaceSelcetAddressFlag = true;
                this.isShowFaceSelectClassesFlag = false;
                this.isShowFaceSelectClassesDetailFlag = false;

                this.getMyCourse();
            }
        },

        // jumpSelectClasses () {
        //     this.isShowFaceSelcetAddressFlag = false;
        //     this.isShowFaceSelectClassesDetailFlag = false;
        //     this.isShowFaceSelectClassesFlag = true;
        // },
        // seeFaceCourseDetail () {
        //     this.isShowFaceSelcetAddressFlag = false;
        //     this.isShowFaceSelectClassesFlag = false;
        //     this.isShowFaceSelectClassesDetailFlag = true;
        // },

        // closeConfirmSignUpPop () {
        //     this.isShowConfirmOnlineCourseSignUpPopFlag = false;
        // },

        // onlineSignUpNowEvent () {
        //     this.isShowoOnlineCourseListFlag = false;
        //     this.isShowConfirmOnlineCourseSignUpList = true;
        //     this.isShowConfirmOnlineCourseSignUpPopFlag = false;

        // },

        // continueOnlineSelectCourseEvent () {
        //     this.isShowoOnlineCourseListFlag = true;
        //     this.isShowConfirmOnlineCourseSignUpList = false;
        //     this.isShowConfirmOnlineCourseSignUpPopFlag = false;

        // },

        // confirmSignUpOnlineCourseEvent () {
        //     this.isShowoOnlineCourseListFlag = false;
        //     this.isShowConfirmOnlineCourseSignUpList = true;
        //     this.isShowConfirmOnlineCourseSignUpPopFlag = true;
        // },



    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media (min-width: 1399px) {
    .el-container-master {
        width: 1400px;
        margin: auto;
    }
}

.el-aside {
    background: #fff;
}

.el-main {
    padding: 0;
    background: #fff;
}

.content {
    padding: 47px 57px 0 86px;
    flex: 1;
    border-top: 10px solid #f8f8f8;
    border-left: 10px solid #f8f8f8;
}

/* .content {
  width:1400px;
  margin: 0 auto;
  padding-bottom:40px;
} */

.onlineTeachingContRight {
    background: #fff;
    /* box-shadow:0px 0px 15px 0px rgba(218,218,218,0.5);
  position:relative;
  left:-2px; */
}

.onlineTeachingCont {
    /* overflow: hidden; */
    padding-bottom: 50px;
}

.onlineTeachingContPadding {
    /* padding:50px; */
    background: #fff;
    border-radius: 4px;
}

.classTypesTab,
.onlineConfirmSignUpBtns {
    overflow: hidden;
    margin: 0 auto;
    text-align: center;
}
.classTypesTab > p {
    display: inline-block;
    margin: 0 35px;
    width: 110px;
    height: 38px;
    line-height: 38px;
    text-align: center;
    color: #0173ff;
    font-size: 16px;
    letter-spacing: 2px;
    border: 1px solid #43affc;
    border-radius: 4px;
    cursor: pointer;
}
.classTypesSelect .el-select{
    width: 100px;
}

.onlineConfirmSignUpBtns {
    margin-top: 100px;
}
.onlineConfirmSignUpBtns > p {
    display: inline-block;
    margin: 0 35px;
    width: 140px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 16px;
    letter-spacing: 2px;
    border: 1px solid #43affc;
    border-radius: 4px;
    cursor: pointer;
}

.classTypesTab > p.active {
    background-image: -webkit-linear-gradient(left, #4bb7fc, #0173ff);
    background-image: -o-linear-gradient(left, #4bb7fc, #0173ff);
    background-image: -ms-linear-gradient(left, #4bb7fc, #0173ff);
    background-image: linear-gradient(left, #4bb7fc, #0173ff);
    color: #fff;
    border: none;
}

.onlineTeachingContTop {
    position: relative;
}

.classTypesSelect {
    position: absolute;
    left: 0px;
    top: 0;
}

.compulsoryCourseCont {
    margin-top: 50px;
}

.compulsoryCourseTitle {
    font-size: 18px;
    color: #333;
    padding-left: 10px;
    border-left: 4px solid #0173ff;
    font-weight: bold;
}

.compulsoryCourseList {
    margin: 0 5px 0 10px;
}
.compulsoryCourseList li {
    padding: 10px;
    overflow: hidden;
    border-radius: 8px;
    margin-top: 20px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 15px 0px rgba(218, 218, 218, 0.5);
    position: relative;
}
.compulsoryCourseImg img {
    width: 105px;
    height: 80px;
    display: block;
}

.compulsoryCourseImgInfor {
    max-width: 55%;
    margin-left: 15px;
}

.compulsoryCourseImgTitle {
    width: 100%;
    color: #333;
    font-weight: bold;
}
.compulsoryCourseImgTitle,
.compulsoryCourseScore {
    margin-top: 12px;
}
.compulsoryCourseScore {
    color: #666;
    font-size: 14px;
}


.electiveCoursesCont {
    margin-top: 50px;
}

.chooseResultCont {
    background: rgba(228, 240, 253, 1);
    height: 40px;
    line-height: 40px;
    color: #333;
    text-align: center;
    font-size: 14px;
    margin-top: 30px;
    width: 1170px;
    position: relative;
    left: -86px;
}

.signUpNowBtn {
    height: 42px;
    line-height: 42px;
    text-align: center;
    color: #fff;
    width: 290px;
    margin: 50px auto 0;
    border-radius: 4px;
    cursor: pointer;
    letter-spacing: 2px;
}

.blueGradient {
    background-image: -webkit-linear-gradient(left, #4bb7fc, rgb(31, 132, 255));
    background-image: -o-linear-gradient(left, #4bb7fc, rgb(31, 132, 255));
    background-image: -ms-linear-gradient(left, #4bb7fc, rgb(31, 132, 255));
    background-image: linear-gradient(left, #4bb7fc, rgb(31, 132, 255));
    color: #fff;
}

.buttonBorderStyle {
    color: #0173ff;
    border: 1px solid #0173ff;
}

.selectClassesList .compulsoryCourseImgInfor {
    position: relative;
    top: -6px;
}

.signUpStatus {
    position: absolute;
    top: 25px;
    color: #999;
    font-size: 12px;
    right: 35px;
}

.selectClassesList {
    margin-top: 40px;
}

.faceCourseDetail {
    margin: 30px 30px 0 15px;
}
.faceCourseDetail > p {
    color: #333;
    line-height: 24px;
    margin-top: 10px;
    font-size: 14px;
}

.classScheduleTitle {
    width: 78%;
    float: left;
}

.classScheduleTeacher {
    float: left;
    margin-left: 50px;
}

.confirmSignUpTitle span {
    margin-right: 50px;
}
.confirmSignUpTitle span font {
    color: #0475ff;
}

.faceCompulsoryCourseList {
}
.dividingLine {
    height: 12px;
    background: rgba(248, 248, 248, 1);
}

.onlineCourseConfirmSignUpPop {
}

.coverLayer {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
}

.onlineCourseConfirmSignUpPopCont {
    position: fixed;
    width: 1050px;
    padding: 50px 35px;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    border-radius: 4px;
}

.closeBtn {
    position: absolute;

    right: 12px;
    top: 5px;
    font-size: 32px;
    cursor: pointer;
}
.closeBtn:hover {
    color: #0475ff;
}
.player p{
      text-align: left;
      text-indent: 2em;
      margin-bottom: 10px;
}
.player p a{
  color: #0173ff;
  text-decoration: underline;
}


</style>



// WEBPACK FOOTER //
// src/components/my/signStudy/index.vue